import { Navigate } from 'react-router-dom'

import { useSession } from '@/lib/auth'
import SessionUnknown from '@/components/auth/SessionUnknown'

/**
 * /admin → /admin/calendar dla wszystkich z dostępem (canManagePersonnel).
 * Po M6c-2 nie ma rozróżnienia między ADMIN a Manager/Księgowa — wszyscy lądują
 * na kalendarzu jako głównym workspace.
 */
export default function AdminIndexRedirect() {
  const session = useSession()
  // Jak w RequireAuth: /login tylko po 401 (data === null), nigdy po błędzie sieci.
  if (session.data === undefined) return <SessionUnknown />
  if (session.data === null) return <Navigate to="/login" replace />
  return <Navigate to="/admin/calendar" replace />
}
